import React from 'react'
import PropTypes from 'prop-types'

function ButtonOption ({
  item,
  itemToString,
  toggleItem,
  className,
  disabled,
  key,
  ...props
}) {
  return (
    <button
      type='button'
      className={className}
      key={key}
      onClick={() => toggleItem(item)}
      disabled={disabled}
    >
      {itemToString(item)}
    </button>
  )
}

ButtonOption.propTypes = {
  item: PropTypes.any,
  toggleItem: PropTypes.func,
  isSelected: PropTypes.func,
  itemToString: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  key: PropTypes.string
}

export default ButtonOption
